import { FC } from "react";
import styled from "styled-components";
import ReactSlider from "react-slider";

const BONUSES_PER_CLICK = 10;

interface WithdrawBonuses {
  value: number;
  setValue: React.Dispatch<React.SetStateAction<number>>;
  balance: number;
  total: number;
}

const WithdrawBonuses: FC<WithdrawBonuses> = ({
  value,
  setValue,
  balance,
  total,
}) => {
  return (
    <>
      <Title>Cписать бонусы</Title>
      <Text>На счете {balance} бонусов</Text>
      <SliderWrap>
        <StyledSlider
          value={value}
          onChange={setValue}
          renderTrack={Track}
          renderThumb={Thumb}
          max={total}
        />
        <Row>
          <Button
            $hide={value <= 0}
            type="button"
            onClick={() => {
              setValue((v) => {
                if (v < BONUSES_PER_CLICK) {
                  return 0;
                }
                return v - BONUSES_PER_CLICK;
              });
            }}
          >
            <Minus />
          </Button>
          <Value>{value}₽</Value>
          <Button
            $hide={value >= total}
            type="button"
            onClick={() => {
              setValue((v) => {
                if (value > total - BONUSES_PER_CLICK) {
                  return total;
                }
                return v + BONUSES_PER_CLICK;
              });
            }}
          >
            <Plus />
          </Button>
        </Row>
      </SliderWrap>
    </>
  );
};

const SliderWrap = styled.div`
  position: relative;
`;

const Row = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 3px;
  pointer-events: none;
`;

interface IButton {
  $hide: boolean;
}
const Button = styled.button<IButton>`
  display: flex;
  visibility: ${({ $hide }) => ($hide ? "hidden" : "visible")};
  align-items: center;
  justify-content: center;
  padding: 0;
  width: 29px;
  height: 29px;
  border: none;
  background: #fff;
  border-radius: 7px;
  pointer-events: initial;
`;

const Minus = styled.span`
  display: block;
  width: 16px;
  height: 16px;
  background: url("/static/icons/minus-slider.svg") no-repeat center;
`;

const Plus = styled.span`
  display: block;
  width: 16px;
  height: 16px;
  background: url("/static/icons/plus-slider.svg") no-repeat center;
`;

const Title = styled.p`
  font-size: 14px;
  line-height: 1.2;
  margin: 0 0 3px;
`;

const Text = styled.p`
  font-size: 12px;
  line-height: 1.2;
  margin: 0 0 14px;
  opacity: 0.5;
`;

const StyledSlider = styled(ReactSlider)`
  width: 100%;
  height: 35px;
  border-radius: 10px;
  overflow: hidden;
`;

const StyledThumb = styled.div`
  display: none;
`;

const Thumb = (props) => <StyledThumb {...props} />;

const StyledTrack = styled.div`
  top: 0;
  bottom: 0;
  background: ${(props) => (props.index === 1 ? "#F5F4F0" : "#FFDD02")};
  border-radius: ${(props) =>
    props.index === 1 ? "0 10px 10px 0" : "10px 0 0 10px"};
`;

const Track = (props, state) => <StyledTrack {...props} index={state.index} />;

const Value = styled.span`
  display: block;
  font-size: 20px;
`;

export default WithdrawBonuses;
